import { cn } from '@/lib/utils'
import type { Tag } from '@/lib/types'

interface TagChipProps {
  tag: Tag
  selected?: boolean
  onClick?: () => void
  size?: 'sm' | 'md'
}

export default function TagChip({ tag, selected, onClick, size = 'md' }: TagChipProps) {
  const interactive = !!onClick
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={!interactive}
      title={tag.description}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border font-medium transition-colors',
        size === 'md' ? 'min-h-[44px] px-4 py-2 text-sm' : 'px-2.5 py-0.5 text-xs',
        selected
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-border bg-card text-foreground',
        interactive && !selected && 'hover:border-primary/50 hover:bg-secondary',
        !interactive && 'cursor-default'
      )}
    >
      {tag.name}
      {selected && <span aria-hidden>✓</span>}
    </button>
  )
}
